import * as Sentry from "@sentry/vue";

const isError = ([, items]) => items.some(([{ type }]) => type === "event");

const offlineTransport = Sentry.makeBrowserOfflineTransport(
  Sentry.makeFetchTransport
);

export const makeSentryTransport = (options) => {
  const transport = offlineTransport({
    ...options,
    flushAtStartup: true,
    shouldStore: isError,
  });
  return {
    ...transport,
    send: (envelope) =>
      !isError(envelope) && !globalThis.navigator.onLine
        ? Promise.resolve({})
        : transport.send(envelope),
  };
};
